import { lazy, Suspense } from 'react';
import { useAppDispatch } from 'app/hooks';
import If from 'components/If';
import Spin from 'components/Spin';
import { setToastAlert } from 'services/toast-alert/toastAlertSlice';
import { ToastAlertSliceType } from 'services/toast-alert/types';
import { convertToBillableOffer } from 'services/ctp/ctpAsync';
import { setIsExpiryNoticeModalClosed } from 'services/ctp/ctpSlice';

const CtpModal = lazy(() => import('pages/convert-to-pay/partials/ctp-modal'));

type Props = {
  isOpen: boolean;
  handleNextModalSequence: () => void;
};

function MembershipExpiryNotice({ handleNextModalSequence, isOpen }: Props) {
  const dispatch = useAppDispatch();

  const dispatchAlertToast = (toastAlertData: ToastAlertSliceType) => {
    dispatch(setToastAlert(toastAlertData));
  };

  const handleModalClose = () => {
    dispatch(setIsExpiryNoticeModalClosed(true));
    handleNextModalSequence();
  };

  const handleCTPSubmit = async (data: {
    token?: string;
    offerCode: string;
  }) => {
    try {
      await dispatch(convertToBillableOffer(data));
      dispatchAlertToast({
        status: 'success',
        message: 'Your membership has been updated.',
      });
      return 'true';
    } catch (error) {
      dispatchAlertToast({
        status: 'error',
        message: 'Your membership cannot be updated. Please try again later.',
      });
      return Promise.reject(error);
    }
  };

  return (
    <If condition={isOpen}>
      <Suspense fallback={<Spin fullscreen />}>
        <CtpModal
          isOpen
          handleClose={handleModalClose}
          handleSubmit={handleCTPSubmit}
        />
      </Suspense>
    </If>
  );
}

export default MembershipExpiryNotice;
